// extracted by mini-css-extract-plugin
export var button = "_dr-4";
export var hasDarkBackground = "_dr-7";
export var hasLightBackground = "_dr-6";
export var iconWrapper = "_dr-0";
export var large = "_dr-2";
export var medium = "_dr-1";
export var small = "_dr-5";
export var xsmall = "_dr-3";